export default () => {
    return {
        mounted(delay = this.$store.animationDelay, scrollTrigger = true) {
            let stSettings = false;

            if (scrollTrigger) {
                stSettings = {
                    start: 'top 85%',
                    trigger: this.$refs.graphic
                };
            }

            const draw = gsap.timeline({ scrollTrigger: stSettings });

            draw.fromTo(
                this.$refs.ringLeft,
                {
                    drawSVG: '0 0'
                },
                {
                    drawSVG: '0 100%',
                    duration: 1.2,
                    delay: delay,
                    ease: 'circ.inOut',
                    scrollTrigger: stSettings
                }
            ).fromTo(
                this.$refs.ringRight,
                {
                    drawSVG: '100% 100%'
                },
                {
                    drawSVG: '0 100%',
                    duration: 1.2,
                    ease: 'circ.inOut',
                    scrollTrigger: stSettings
                },
                '<0.4'
            );
        }
    };
};
